<template>
  <div>
    <div v-if="message">
      <b-alert :show="true" variant="success">
        <div class="iq-alert-text">{{ message }}</div>
      </b-alert>
      <p>We have sent you an email with further instructions.</p>
      <p>
        To set password for your account follow the link sent by email or click
        <a href="/auth/reset-password">here</a>
      </p>
    </div>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }" v-else>
      <p>Enter your email and the name of your organization.</p>
      <form
        class="mt-4"
        novalidate
        @submit.prevent="handleSubmit(onSubmit)"
        data-cy="register-form"
      >
        <ValidationProvider
          vid="organizationName"
          name="Organization name"
          rules="required"
          v-slot="{ errors }"
        >
          <div class="form-group">
            <label for="organizationName">Name of your organization</label>
            <input
              type="text"
              :class="
                'form-control mb-0' + (errors.length > 0 ? ' is-invalid' : '')
              "
              id="organizationName"
              data-cy="organization-name-input"
              v-model="organizationName"
              placeholder="My organization"
              required
              :disabled="loading"
            />
            <div class="invalid-feedback">
              <span>{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>
        <ValidationProvider
          vid="email"
          name="E-mail"
          rules="required|email"
          v-slot="{ errors }"
        >
          <div class="form-group">
            <label for="emailInput"
              >Your email address
              <i class="ri-question-fill" id="popover-email-info"></i>
              <b-popover
                target="popover-email-info"
                variant="danger"
                xtriggers="focus"
                style="max-width: 500px"
              >
                <div style="display: flex; flex-direction: column">
                  <p>Every email address can be registered only once.</p>
                  <p>
                    Please check also SPAM of your email address after
                    submitting registration.
                  </p>
                </div>
              </b-popover>
            </label>
            <input
              type="email"
              :class="
                'form-control mb-0' + (errors.length > 0 ? ' is-invalid' : '')
              "
              id="emailInput"
              data-cy="email-input"
              aria-describedby="emailHelp"
              v-model="email"
              placeholder="Enter email"
              required
              :disabled="loading"
            />
            <div class="invalid-feedback">
              <span>{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>
        <ValidationProvider
          vid="terms"
          name="terms"
          rules="required"
          v-slot="{ errors }"
        >
          <div class="form-group">
            <b-checkbox
              id="terms"
              class="custom-switch-color"
              name="terms"
              inline
              v-model="termsAgreed"
              data-cy="terms-checkbox"
              >I agree to the
              <a href="https://www.omnicrane.com/en/terms" target="_blank"
                >terms & conditions</a
              >
              of application usage and
              <a href="https://www.omnicrane.com/en/privacy" target="_blank"
                >privacy policy</a
              >.</b-checkbox
            >
            <div class="invalid-feedback">
              <span>{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>

        <div class="d-inline-block w-100">
          <button
            v-if="!loading"
            type="submit"
            data-cy="submit-button"
            class="btn btn-primary float-right"
            :disabled="!termsAgreed"
          >
            Create account
          </button>
          <button
            v-if="loading"
            type="submit"
            class="btn btn-primary float-right"
            disabled
          >
            Creating account...
          </button>
        </div>
      </form>
    </ValidationObserver>

    <div class="mt-4" v-if="!message">
      <b-alert :show="true" variant="primary" class="bg-white">
        <div class="iq-alert-text">
          <h4 class="alert-heading mb-4">Trial license</h4>
          <p>
            After registration you will be granted Trial licence
            <strong>valid for 30 days</strong>. This license allows you to have
            3 users, send campaign to 100 contacts and import 100 contacts.
          </p>
          <p>
            The license can be upgraded at any time by sending a request to
            support@omnicrane.com. For more details on license comparison,
            please click
            <a
              href="https://www.omnicrane.com/en/price-list#comparision"
              style="text-decoration: underline"
              target="_blank"
              >here</a
            >.
          </p>
        </div>
      </b-alert>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
const REGISTER_MUTATION = gql`
  mutation register($organizationName: String!, $username: String!) {
    register(organizationName: $organizationName, username: $username) {
      organizationId
      userId
    }
  }
`;
export default {
  name: "RegisterForm",
  data() {
    return {
      loading: false,
      organizationName: "",
      email: "",
      message: "",
      termsAgreed: false
    };
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      try {
        await this.$apollo.mutate({
          mutation: REGISTER_MUTATION,
          variables: {
            organizationName: this.organizationName,
            username: this.email
          }
        });
        this.loading = false;
        this.$toast.success(`Registration completed`);
        this.message =
          "Account successfully created. We have sent you an email with further instructions.";
      } catch (error) {
        this.loading = false;
        this.$toast.error(`Failed to register: ${error.message}`);
      }
    }
  }
};
</script>

<style scoped>
button:disabled {
  opacity: 0.25 !important;
}
.iq-alert-text {
  color: rgba(0, 0, 0, 0.8);
}
</style>
